(() => {
  if (window.mettaExperiencesReady) return;
  window.mettaExperiencesReady = true;
  const labels = document.getElementById('metta-experiences')?.dataset || {};
  if (!customElements.get('image-lens')) customElements.define('image-lens', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.source = this.querySelector('img');
      if (!this.source) return;
      this.lens = document.createElement('span');
      this.lens.className = 'psy-lens';
      this.lens.setAttribute('aria-hidden', 'true');
      this.zoom = this.source.cloneNode();
      this.zoom.removeAttribute('id');
      this.zoom.alt = '';
      this.zoom.loading = 'eager';
      this.lens.append(this.zoom);
      this.button = document.createElement('button');
      this.button.type = 'button';
      this.button.className = 'psy-lens-toggle';
      this.button.textContent = labels.zoom || 'Zoom image';
      this.button.setAttribute('aria-pressed', 'false');
      this.append(this.lens, this.button);
      this.button.addEventListener('click', () => {
        this.pinned = !this.pinned;
        this.button.setAttribute('aria-pressed', String(this.pinned));
        this.button.textContent = this.pinned ? labels.closeZoom || 'Close zoom' : labels.zoom || 'Zoom image';
        if (this.pinned) this.show(); else this.classList.remove('is-lens-active');
      }, {signal});
      this.addEventListener('pointermove', event => {
        if (event.target.closest('button')) return;
        if (event.pointerType === 'mouse' || this.pinned) this.show(event.clientX, event.clientY);
      }, {signal});
      this.addEventListener('pointerleave', () => { if (!this.pinned) this.classList.remove('is-lens-active'); }, {signal});
      this.addEventListener('keydown', event => { if (event.key === 'Escape') { this.pinned = false; this.button.setAttribute('aria-pressed', 'false'); this.button.textContent = labels.zoom || 'Zoom image'; this.classList.remove('is-lens-active'); } }, {signal});
      this.resize = new ResizeObserver(() => { if (this.pinned) this.show(); });
      this.resize.observe(this);
    }
    show(clientX, clientY) {
      const box = this.source.getBoundingClientRect();
      if (!box.width || !box.height) return;
      const radius = Math.min(85, box.width * .25);
      const x = Math.max(radius, Math.min(box.width - radius, clientX === undefined ? box.width / 2 : clientX - box.left));
      const y = Math.max(radius, Math.min(box.height - radius, clientY === undefined ? box.height / 2 : clientY - box.top));
      const factor = 1.85;
      Object.assign(this.lens.style, {width:`${radius * 2}px`,height:`${radius * 2}px`,left:`${x - radius}px`,top:`${y - radius}px`});
      Object.assign(this.zoom.style, {width:`${box.width * factor}px`,height:`${box.height * factor}px`,left:`${radius - x * factor}px`,top:`${radius - y * factor}px`,objectFit:getComputedStyle(this.source).objectFit,objectPosition:getComputedStyle(this.source).objectPosition});
      this.classList.add('is-lens-active');
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; this.resize?.disconnect(); this.lens?.remove(); this.button?.remove(); }
  });
  const fine = matchMedia('(hover:hover) and (pointer:fine)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const follower = document.createElement('div');
  follower.className = 'psy-follow-pointer';
  follower.setAttribute('aria-hidden', 'true');
  follower.innerHTML = '<svg width="26" height="18" viewBox="0 0 26 18" fill="none"><path d="M1 9S5 2 13 2s12 7 12 7-4 7-12 7S1 9 1 9Z" stroke="currentColor" stroke-width="1.4"/><circle cx="13" cy="9" r="3" fill="currentColor"/></svg><span></span>';
  follower.querySelector('span').textContent = labels.explore || 'View piece';
  document.body.append(follower);
  let frame, targetX = 0, targetY = 0, x = 0, y = 0, active = false;
  const hide = () => { active = false; follower.classList.remove('is-visible'); cancelAnimationFrame(frame); frame = null; };
  const draw = () => {
    if (!active) return;
    x += (targetX - x) * .22; y += (targetY - y) * .22;
    follower.style.transform = `translate3d(${x}px,${y}px,0)`;
    frame = requestAnimationFrame(draw);
  };
  document.addEventListener('pointermove', event => {
    if (!fine.matches || reduced.matches || event.pointerType !== 'mouse') return hide();
    const card = event.target.closest('.card-wrapper');
    const media = card?.querySelector('.card__media');
    const link = card?.querySelector('a[href*="/products/"]');
    if (!media || !link || event.target.closest('button,input,select,textarea,dialog')) return hide();
    const bounds = media.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) return hide();
    targetX = Math.min(event.clientX + 18, innerWidth - 150);
    targetY = Math.min(event.clientY + 20, innerHeight - 56);
    if (!active) { x = targetX; y = targetY; active = true; follower.classList.add('is-visible'); draw(); }
  }, {passive:true});
  document.addEventListener('pointerout', event => { if (!event.relatedTarget) hide(); });
  document.addEventListener('scroll', hide, {passive:true});
  document.addEventListener('visibilitychange', hide);
  fine.addEventListener('change', hide);
  reduced.addEventListener('change', hide);
})();
